import { XCentiumProductAvailabilityActions } from "@electricMotorShop/Store/Components/ProductAvailability/ProductAvailabilityReducer";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type Props = DispatchProp<XCentiumProductAvailabilityActions>;

type HandlerType = Handler<{ isLoading: boolean }, Props>;

export const DispatchSetIsLoading: HandlerType = ({ dispatch, parameter: { isLoading } }) => {
    dispatch({
        type: "Custom/ProductAvailability/SetIsLoading",
        isLoading,
    });
};

export const chain = [DispatchSetIsLoading];

const setInventoryIsLoading = createHandlerChainRunner(chain, "setInventoryIsLoading");
export default setInventoryIsLoading;
